/* @ngInject */
function InactiveController ($scope, $timeout, $location, $stateParams, AuthService) {
  var sHost = $location.host()
  $scope.subdomain = ''
  $scope.sCustomerLogoPath = ''
  $scope.backgroundImageUrl = ''
  $scope.backgroundUrl = ''
  $scope.flags = {
    loadingLogo: true,
    loadingBackground: true
  }

  activate()

  function activate () {
    AuthService.setContainerPosition()
    $scope.isPending = $stateParams.isPending

    AuthService.getCustomerImages(sHost)
      .then(url => {
        $scope.subdomain = localStorage.getItem('companySubdomain')
        $scope.sCustomerLogoPath = url.logo
        $scope.backgroundUrl = url.background
      })
  }

  $scope.onLogoLoad = function () {
    $timeout(() => {
      $scope.flags.loadingLogo = false
    })
  }

  $scope.onBackgroundLoad = function () {
    $timeout(() => {
      $scope.backgroundImageUrl = $scope.backgroundUrl
      $scope.flags.loadingBackground = false
    })
  }
}

export { InactiveController }
